import { Dispatch, FunctionComponent, SetStateAction, useState } from "react";
import { Checkbox, Dropdown } from "antd";
import BasicButton from "@components/core/buttons/BasicButton";
import ChevronDownIcon from "@static/core/icons/icon-chevron-down.svg?react";
import { useTranslation } from "react-i18next";
import { Filters } from "@type/core/dashboard/dashboard.types";
import { Office } from "@type/core/offices/offices.types";

interface StatusFilterProps {
  filters: {
    signature: string[];
    cabinet: Office[];
    status: string[];
  };
  selectedFilters: Filters;
  setSelectedFilters: Dispatch<SetStateAction<Filters>>;
  className?: string;
}

const StatusFilter: FunctionComponent<StatusFilterProps> = ({
  filters,
  selectedFilters,
  setSelectedFilters,
  className = "",
}) => {
  const { t } = useTranslation();
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] =
    useState<boolean>(false);

  const handleClick = (name: string, isAllSelected: boolean) => {
    const newSelected = filters.status.filter((item) => {
      if (name === "all") {
        return !isAllSelected;
      }
      if (item === name) {
        return selectedFilters.status.indexOf(item) === -1;
      } else {
        return selectedFilters.status.indexOf(item) !== -1;
      }
    });
    setSelectedFilters({
      ...selectedFilters,
      status: newSelected,
    });
  };
  const onRightClick = (name: string, isAllSelected: boolean) => {
    const newSelected = filters.status.filter((item) => {
      if (name === "all") {
        return !isAllSelected;
      }
      return item === name;
    });
    setSelectedFilters({
      ...selectedFilters,
      status: newSelected,
    });
  };

  return (
    <div className={`app-filter-status ${className}`}>
      <Dropdown
        overlayClassName="dropdown-filter-overlay"
        menu={{
          items: [
            {
              name: "all",
              selected: selectedFilters.status.length === filters.status.length,
            },
          ]
            .concat(
              filters.status.map((status) => ({
                name: status,
                selected: selectedFilters.status.indexOf(status) !== -1,
              })),
            )
            .map((status, index) => {
              return {
                key: index,
                label: (
                  <div
                    className="w-100"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleClick(
                        status.name,
                        selectedFilters.status.length === filters.status.length,
                      );
                    }}
                    onContextMenu={(e) => {
                      e.preventDefault();
                      if (onRightClick) {
                        onRightClick(
                          status.name,
                          selectedFilters.status.length ===
                            filters.status.length,
                        );
                      }
                    }}
                  >
                    <Checkbox
                      id={`${status.name}_${index}`}
                      checked={status.selected}
                      onChange={(e) => e.preventDefault()}
                      className="checkbox-carded"
                    >
                      {t(`home.dashboard.filters.${status.name}`)}
                    </Checkbox>
                  </div>
                ),
              };
            }),
        }}
        trigger={["click"]}
        onOpenChange={(open) => setIsStatusDropdownOpen(open)}
      >
        <BasicButton
          className="filters-dropdown-button"
          variant={
            selectedFilters.status.length > 0 || isStatusDropdownOpen
              ? "primary"
              : "primary-outlined"
          }
          text={
            <div className="d-flex align-items-center justify-content-center">
              <span className="text-nowrap">
                {t("home.dashboard.filters.status")}
              </span>
              <strong className="ml-4">{selectedFilters.status.length}</strong>
            </div>
          }
          icon={<ChevronDownIcon />}
        />
      </Dropdown>
    </div>
  );
};

export default StatusFilter;
